var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import { LoadingOrError } from "../components/common/LoadingOrError";
import { ConfigContext, isConfiguration, } from "../utils/types/config";
export var ConfigProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(null), config = _c[0], setConfig = _c[1];
    useEffect(function () {
        var fetchConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
            var resp, jsonData, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch("/api/config")];
                    case 1:
                        resp = _a.sent();
                        return [4 /*yield*/, resp.json()];
                    case 2:
                        jsonData = _a.sent();
                        if (isConfiguration(jsonData)) {
                            setConfig(jsonData);
                        }
                        else {
                            setError(new Error("Could not unmarshal data as Configuration\n\tGOT:\n\n".concat(JSON.stringify(jsonData, null, 2))));
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        setError(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchConfig();
    }, []);
    return (<LoadingOrError loading={!config} error={error}>
      <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
    </LoadingOrError>);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29uZmlnUHJvdmlkZXIuanN4Iiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiQ29uZmlnUHJvdmlkZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLE9BQU8sS0FBSyxFQUFFLEVBQUUsUUFBUSxFQUFFLFNBQVMsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQUVuRCxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0scUNBQXFDLENBQUM7QUFDckUsT0FBTyxFQUNMLGFBQWEsRUFFYixlQUFlLEdBQ2hCLE1BQU0sdUJBQXVCLENBQUM7QUFFL0IsTUFBTSxDQUFDLElBQU0sY0FBYyxHQUFHLFVBQUMsRUFBWTtRQUFWLFFBQVEsY0FBQTtJQUNqQyxJQUFBLEtBQW9CLFFBQVEsQ0FBUSxJQUFJLENBQUMsRUFBeEMsS0FBSyxRQUFBLEVBQUUsUUFBUSxRQUF5QixDQUFDO0lBQzFDLElBQUEsS0FBc0IsUUFBUSxDQUFnQixJQUFJLENBQUMsRUFBbEQsTUFBTSxRQUFBLEVBQUUsU0FBUyxRQUFpQyxDQUFDO0lBRTFELFNBQVMsQ0FBQztRQUNSLElBQU0sV0FBVyxHQUFHOzs7Ozs7d0JBRUgscUJBQU0sS0FBSyxDQUFDLGFBQWEsQ0FBQyxFQUFBOzt3QkFBakMsSUFBSSxHQUFHLFNBQTBCO3dCQUNiLHFCQUFNLElBQUksQ0FBQyxJQUFJLEVBQUUsRUFBQTs7d0JBQXJDLFFBQVEsR0FBWSxTQUFpQjt3QkFDM0MsSUFBSSxlQUFlLENBQUMsUUFBUSxDQUFDLEVBQUU7NEJBQzdCLFNBQVMsQ0FBQyxRQUFRLENBQUMsQ0FBQzt5QkFDckI7NkJBQU07NEJBQ0wsUUFBUSxDQUNOLElBQUksS0FBSyxDQUNQLCtEQUF3RCxJQUFJLENBQUMsU0FBUyxDQUNwRSxRQUFRLEVBQ1IsSUFBSSxFQUNKLENBQUMsQ0FDRixDQUFFLENBQ0osQ0FDRixDQUFDO3lCQUNIOzs7O3dCQUVELFFBQVEsQ0FBQyxHQUFVLENBQUMsQ0FBQzs7Ozs7YUFFeEIsQ0FBQztRQUNGLFdBQVcsRUFBRSxDQUFDO0lBQ2hCLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUVQLE9BQU8sQ0FDTCxDQUFDLGNBQWMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUM3QztNQUFBLENBQUMsYUFBYSxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxFQUFFLGFBQWEsQ0FBQyxRQUFRLENBQzNFO0lBQUEsRUFBRSxjQUFjLENBQUMsQ0FDbEIsQ0FBQztBQUNKLENBQUMsQ0FBQyJ9